// extracted by mini-css-extract-plugin
export var clickableArea = "ProductItem_clickableArea__SHfVc";
export var image = "ProductItem_image__hMeIl";
export var item = "ProductItem_item__-VbZt";
export var price = "ProductItem_price__ZjoxR";
export var promotion = "ProductItem_promotion__EunJL";
export var subtitle = "ProductItem_subtitle__AbLBM";
export var subtitleBold = "ProductItem_subtitleBold__yOPv0";
export var title = "ProductItem_title__lv-zB";